"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIAL_FORM_CONFIG = exports.WRAPPED_SOL_MINT = exports.JLP_MINT = exports.USDT_MINT = exports.USDC_MINT = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.USDC_MINT = new web3_js_1.PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v');
exports.USDT_MINT = new web3_js_1.PublicKey('Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB');
exports.JLP_MINT = new web3_js_1.PublicKey('27G8MtK7VtTcCHkpASjSDdkWWYfoqT6ggEuKidVJidD4');
exports.WRAPPED_SOL_MINT = new web3_js_1.PublicKey('So11111111111111111111111111111111111111112');
exports.INITIAL_FORM_CONFIG = Object.freeze({
    simulateWalletPassthrough: false,
    defaultExplorer: 'Solana Explorer',
    formProps: {
        fixedAmount: false,
        initialAmount: '',
        initialInputMint: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
        initialOutputMint: exports.WRAPPED_SOL_MINT.toString(),
    },
    colors: {
        primary: '199, 242, 132',
        background: '0, 0, 0',
        primaryText: '232, 249, 255',
        warning: '251, 191, 36',
        interactive: '33, 42, 54',
        module: '16, 23, 31',
    },
});
